<button
  [type]="isSubmit ? 'submit' : 'button'"
  class="lum-button"
  mat-button
  [ngClass]="classes"
  [ngStyle]="{ 'background-color': backgroundColor }"
  [disabled]="disabled || loading"
  (click)="clickEvent.emit()"
>
  <ng-container *ngIf="!loading; else loader">
    <ng-content></ng-content>
    {{ label }}
  </ng-container>
  <ng-template #loader>
    <mat-progress-spinner
      class="progress-spinner"
      diameter="16"
      mode="indeterminate"
    ></mat-progress-spinner>
  </ng-template>
</button>
